<template>
  <div>
    <div class="custom-container">
      <b-row>
        <b-col sm="12">
          <card class="p-0">
            <template class="p-0" v-slot:headerTitle>
              <div class="d-flex flex-column align-items-start">
                <h3 class="card-title p-0">
                  <b>Mis Honorarios</b>
                </h3>
              </div>
            </template>
            <div class="row m-3">
              <div class="col-2 px-0">
                <h4 class="mb-2"><b>Mes:</b></h4>
                <b-select v-model="mesSeleccionado" class="form-control bg-dark personalizado" :options="listaMes" text-field="mes" value-field="id" />
              </div>
              <div class="col-1 px-1">
                <h4 class="mb-2"><b>Año:</b></h4>
                <b-select v-model="anioSeleccionado" class="form-control bg-dark personalizado" :options="listaAnios" />
              </div>
              <div class="col-1 px-0 mt-3">
                <vs-button primary class="px-2 py-1" @click="filtrar(1)" id="sendform2">
                  <i class="fas fa-search mr-1"></i>
                </vs-button>
              </div>
              <div class="col px-1">
                <h4 class="mb-2"><b>Selecciona profesional:</b></h4>
                <v-select
                  @input="obtenerDataProfesional()"
                  required
                  class="style-chooser"
                  :reduce="(value) => value"
                  v-model="profesional"
                  :options="listaProfesional"
                  label="nombreProfesional"
                  placeholder="-- selecciona un profesional --"
                ></v-select>
              </div>
              <div class="col px-1">
                <h4 class="mb-2"><b>Selecciona sucursal:</b></h4>
                <v-select
                  required
                  class="style-chooser"
                  :reduce="(value) => value"
                  v-model="sucursal"
                  :options="listaSucursal"
                  label="sucursal"
                  placeholder="-- selecciona opc. --"
                  @input="filtrarDataPorSucursal()"
                ></v-select>
              </div>
              <div class="col-1 px-1 mt-3">
                <vs-button primary class="px-2 py-1" @click="filtrar(2)" id="sendform2">
                  <i class="fas fa-search mr-1"></i>
                </vs-button>
              </div>
            </div>

            <div class="mx-3">
              <b-button v-if="profesional" variant="info" class="float-left mt-3 mr-3" @click="verResumen()">Ver Resumen</b-button>
              <vs-button primary class="float-left mt-3 mr-3 py-1" @click="showModalResumen2">
                <i class="fas fa-link mr-1"></i>
              </vs-button>
              <vs-button primary class="float-left mt-3 mr-3 py-1" @click="generarResumenAll()"> Generar resumen de todos los profesionales </vs-button>
            </div>

            <div class="px-3 pt-3">
              <div class="text-center py-2">
                <label class="h5"
                  ><b>{{ profesional != null ? profesional.nombreProfesional : "" }}</b>
                </label>
              </div>
              <!-- Ttos. realizados, cancelados y evolucionados	 -->
              <div>
                <div class="m-3">
                  <h4><b>Ttos. realizados, cancelados y evolucionados</b></h4>
                </div>
                <table id="datatable_ttos" class="table table-bordered table-responsive-md table-striped text-center">
                  <thead>
                    <tr>
                      <th>Identificación Paciente</th>
                      <th>Paciente nombre</th>
                      <th>Concepto</th>
                      <th>Descripción</th>
                      <th>Tipo</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in listattos" :key="item.id">
                      <td>
                        {{ item.rut }}
                      </td>
                      <td>
                        {{ item.pacienteNombre }}
                      </td>
                      <td>
                        {{ item.concepto }}
                      </td>
                      <td>
                        {{ item.descripcion }}
                      </td>
                      <td>
                        {{ item.tipo }}
                      </td>
                      <td>
                        {{ item.valor.toFixed(0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Costos material especial	 -->
              <div>
                <div class="m-3">
                  <h4><b>Costos material especial</b></h4>
                </div>
                <table id="datatable_ttos" class="table table-bordered table-responsive-md table-striped text-center">
                  <thead>
                    <tr>
                      <th>Identificación Paciente</th>
                      <th>Paciente nombre</th>
                      <th>Concepto</th>
                      <th>Descripción</th>
                      <th>Tipo</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in listaItemsMaterial" :key="item.id">
                      <td>
                        {{ item.rut }}
                      </td>
                      <td>
                        {{ item.pacienteNombre }}
                      </td>
                      <td>
                        {{ item.concepto }}
                      </td>
                      <td>
                        {{ item.descripcion }}
                      </td>
                      <td>
                        {{ item.tipo }}
                      </td>
                      <td>
                        {{ item.valor.toFixed(0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Costos de remisión	 -->
              <div>
                <div class="m-3">
                  <h4><b>Costos de remisión</b></h4>
                </div>
                <table id="datatable_ttos" class="table table-bordered table-responsive-md table-striped text-center">
                  <thead>
                    <tr>
                      <th>Identificación Paciente</th>
                      <th>Paciente nombre</th>
                      <th>Concepto</th>
                      <th>Descripción</th>
                      <th>Tipo</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in listaItemsRemision" :key="item.id">
                      <td>
                        {{ item.rut }}
                      </td>
                      <td>
                        {{ item.pacienteNombre }}
                      </td>
                      <td>
                        {{ item.concepto }}
                      </td>
                      <td>
                        {{ item.descripcion }}
                      </td>
                      <td>
                        {{ item.tipo }}
                      </td>
                      <td>
                        {{ item.valor.toFixed(0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- tabla costos laboratorio -->
              <div id="claboratorio" class="px-3 mt-3">
                <h4 class="card-title px-3">
                  <b>Costos de laboratorio: </b>
                </h4>
                <!-- {{ listaLaboratorio }} -->
                <table id="datatable_ttos" class="table table-bordered table-responsive-md table-striped text-center">
                  <thead>
                    <tr>
                      <th>Identificación Paciente</th>
                      <th>Paciente nombre</th>
                      <th>Concepto</th>
                      <th>Descripción</th>
                      <th>Tipo</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in listaLaboratorio" :key="item.id">
                      <td>
                        {{ item.rut }}
                      </td>
                      <td>
                        {{ item.pacienteNombre }}
                      </td>
                      <td>
                        {{ item.concepto }}
                      </td>
                      <td>
                        {{ item.descripcion }}
                      </td>
                      <td>
                        {{ item.tipo }}
                      </td>
                      <td>
                        {{ item.valor.toFixed(0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- otros conceptos -->
              <div class="m-3">
                <h4><b>Otros conceptos</b></h4>
              </div>
              <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
                <thead>
                  <tr>
                    <th>Identificación Paciente</th>
                    <th>Paciente nombre</th>
                    <th>Concepto</th>
                    <th>Descripción</th>
                    <th>Tipo</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in otrosConceptos" :key="item.id">
                    <td>
                      {{ item.rut }}
                    </td>
                    <td>
                      {{ item.pacienteNombre }}
                    </td>
                    <td>
                      {{ item.concepto }}
                    </td>
                    <td>
                      {{ item.descripcion }}
                    </td>
                    <td>
                      {{ item.tipo }}
                    </td>
                    <td>
                      {{ item.valor.toFixed(0) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </card>
        </b-col>
      </b-row>

      <b-modal no-enforce-focus :title="'Resumen: ' + cadenaMes() + ' ' + anioSeleccionado" id="resumen" size="xl" hide-footer body-class="body-modal-custom">
        <div class="p-2 mb-3 text-center">
          <span class="h5"> {{ profesional != null ? profesional.nombreProfesional : "" }} </span>
        </div>
        <div class="row px-3">
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Ttos. realizados, cancelados y evol. :</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalTtosRealizados.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Costos material especial</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalCostosMaterial.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Costos de remisión</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalCostosRemision.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Costos de laboratorio</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalCostosLaboratorio.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Total agregados</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalAgregados.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Total descuentos</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalDescuentos.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>TOTAL TTOS REALIZADOS, CANCELADOS Y EVOLUCIONADOS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalNetoHonorarios.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>{{ `VALOR NETO HONORARIOS (${PorcentajeSucursal}%)` }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ TotalHonorarios.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Total agregados (excluidos del porcentaje)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalAgregadosExcluidos.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Total descuentos (excluidos del porcentaje)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalDescuentosExcluidos.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ totalFinalNetoHonorarios.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th style="color: green !important">Valor neto a facturar</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <!-- {{ TotalHonorarios.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }} -->
                    {{ totalFinalNetoHonorarios.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>ICA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ (TotalHonorarios * dataIca.tarifaFinal).toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-4 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Retención en la fuente {{ CodigoRetencionEnLaFuente ? CodigoRetencionEnLaFuente.calculoArt : "" }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{
                      (CodigoRetencionEnLaFuente != null && CodigoRetencionEnLaFuente.calculoArt && CodigoRetencionEnLaFuente.calculoArt == 392
                        ? totalFinalNetoHonorarios * 0.11
                        : calculoRetencion383(totalFinalNetoHonorarios)
                      ).toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- <div class="col-6 px-1">
            <table id="datatable_registroServicios" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>{{ `Total honorarios (${PorcentajeSucursal}%)` }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ TotalHonorarios.toLocaleString("es-CO", { style: "currency", currency: "COP" }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>
      </b-modal>
      <b-modal
        id="ModalResumen2"
        class="p-3"
        :title="profesional != null ? profesional.nombreProfesional.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) : ''"
        size="md"
        hide-footer
        centered
      >
        <div>
          <tablaLiquidacion :data="ResumenLiquida" :dataGeneral="dataGeneral" name="Resumen"></tablaLiquidacion>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
// const Swal = require("sweetalert2");

import { core } from "../../../../config/pluginInit";
import * as XLSX from "xlsx";
import tablaLiquidacion from "../../../../components/helexium/tablaLiquidacion.vue";

export default {
  name: "registroServicios",
  components: {
    tablaLiquidacion,
  },
  data() {
    return {
      listaMes: [
        { id: 1, mes: "Enero" },
        { id: 2, mes: "Febrero" },
        { id: 3, mes: "Marzo" },
        { id: 4, mes: "Abril" },
        { id: 5, mes: "Mayo" },
        { id: 6, mes: "Junio" },
        { id: 7, mes: "Julio" },
        { id: 8, mes: "Agosto" },
        { id: 9, mes: "Septiembre" },
        { id: 10, mes: "Octubre" },
        { id: 11, mes: "Noviembre" },
        { id: 12, mes: "Diciembre" },
      ],
      listaAnios: [],
      mesSeleccionado: null,
      anioSeleccionado: null,
      persona: {},
      dataTableInstance: null,
      listaPacientes: [],
      listaProfesional: [],
      listaSucursal: [],
      listaItems: [],
      listaItemsbk: [],

      paciente: null,
      profesional: null,
      sucursal: null,
      listaItemsMaterial: [],
      listaLaboratorio: [],
      listaLaboratorioBk: [],
      listaItemsRemision: [],
      listattos: [],
      Registro: {},
      Periodo: {},
      otrosConceptos: [],
      otrosConceptosBk: [],
      pacienteManual: "",
      totalAgregados: 0,
      totalDescuentos: 0,
      totalTtosRealizados: 0,
      totalCostosMaterial: 0,
      totalCostosRemision: 0,
      totalCostosLaboratorio: 0,
      totalNetoHonorarios: 0,

      activaTablas: false,
      PorcentajeSucursal: 0,
      TotalHonorarios: 0,

      totalFinalNetoHonorarios: 0,
      totalDescuentosExcluidos: 0,
      totalAgregadosExcluidos: 0,

      listaIca: [],
      dataIca: {},
      estadoLiquidacion: null,
      CodigoRetencionEnLaFuente: null,
      ResumenLiquida: {},
      dataGeneral: {},
    };
  },
  async mounted() {
    // await this.obtenerPorcentajeSucursal();
    this.getIca();
    const anioActual = new Date().getFullYear();
    const anioInicio = anioActual - 2;
    const listaAnios = [];

    for (let anio = anioInicio; anio <= anioActual; anio++) {
      listaAnios.push(anio);
    }
    this.listaAnios = listaAnios;
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.listaItems = [];
    this.mesSeleccionado = new Date().getMonth();
    this.anioSeleccionado = new Date().getFullYear();
    this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(this.anioSeleccionado, this.mesSeleccionado);
    if (window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
      window.$("#datatable_registroServicios").DataTable().destroy();
    }

    core.index();
  },
  methods: {
    generarResumenAll() {},
    showModalResumen2() {
      this.dataGeneral = {
        nombre: this.profesional,
        retencionEnLaFuenteArt: this.CodigoRetencionEnLaFuente && this.CodigoRetencionEnLaFuente.calculoArt ? this.CodigoRetencionEnLaFuente.calculoArt : "--",
      };
      let garantias = this.otrosConceptos.filter((x) => x.descripcion.includes("DTO DE GARANTIA"));
      let sumaGarantias = garantias.reduce((a, b) => {
        return a + b.valor;
      }, 0);
      let otrasDeducciones = this.otrosConceptos.filter((x) => x.descripcion.includes("DTO") && x.tipo == "Comentario" && !x.descripcion.includes("DTO DE GARANTIA"));
      let sumaOtrasDeducciones = otrasDeducciones.reduce((a, b) => {
        return a + b.valor;
      }, 0);
      let retencion =
        this.CodigoRetencionEnLaFuente != null && this.CodigoRetencionEnLaFuente.calculoArt && this.CodigoRetencionEnLaFuente.calculoArt == 392
          ? Math.round(this.totalFinalNetoHonorarios * 0.11)
          : Math.round(this.calculoRetencion383(this.totalFinalNetoHonorarios));
      let ica = Math.round(this.totalFinalNetoHonorarios * this.dataIca.tarifaFinal);
      let gastosFinancieros = 6000;
      let totalDeducciones = Math.round(Number(sumaOtrasDeducciones) + Number(sumaGarantias) + Number(retencion) + Number(ica) + Number(gastosFinancieros));
      this.ResumenLiquida = {
        gastosFinancieros: gastosFinancieros,
        valorAFacturar: Math.round(this.totalFinalNetoHonorarios),
        retencionEnLaFuente: retencion,
        ica: ica,
        otrasDeducciones: sumaOtrasDeducciones,
        garantias: sumaGarantias,
        totalDeducciones: totalDeducciones,
        totalAPagar: Math.round(this.totalFinalNetoHonorarios - totalDeducciones),
      };
      this.$bvModal.show("ModalResumen2");
    },
    calculoRetencion383(base) {
      console.log("base base", base);
      let baseAportes = (base * 0.4).toFixed(2);
      console.log("base baseAportes ", baseAportes);
      let aportesObligatoriosFP = (baseAportes * 0.16).toFixed(2);
      console.log("base aportesObligatoriosFP ", aportesObligatoriosFP);
      let aportesObligatorioS = (baseAportes * 0.125).toFixed(2);
      console.log("base aportesObligatorioS ", aportesObligatorioS);
      let totingresosnrngo = (Number(aportesObligatoriosFP) + Number(aportesObligatorioS)).toFixed(2);
      console.log("base totingresosnrngo ", totingresosnrngo);
      let subtotal1 = (Number(base) - Number(totingresosnrngo)).toFixed(2);
      console.log("base subtotal1 ", subtotal1);
      let limite30Porciento = (Number(base) * 0.3).toFixed(2);
      console.log("base limite30Porciento ", limite30Porciento);
      let subTotal3 = Number(subtotal1);
      console.log("base subTotal3 ", subTotal3);
      let rentasExentas = Number(subTotal3 * 0.25);
      console.log("base rentasExcentas ", rentasExentas);
      let totalRentasExentas = Number(rentasExentas);
      console.log("base totalRentasExentas ", totalRentasExentas);
      let baseGravableInicial = Number(subTotal3 - rentasExentas).toFixed(2);
      console.log("base baseGravableInicial ", baseGravableInicial);
      let deduccionesMasRentasExentas = Number(totalRentasExentas).toFixed(2);
      console.log("base deduccionesMasRentasExentas ", deduccionesMasRentasExentas);
      let MaximoVlrDedMasRExentas = Number(subtotal1 * 0.4).toFixed(2);
      console.log("base MaximoVlrDedMasRExentas ", MaximoVlrDedMasRExentas);
      let BaseMensualDeRetencion = Number(baseGravableInicial).toFixed(2);
      console.log("base BaseMensualDeRetencion ", BaseMensualDeRetencion);
      let ValorUVT2024 = 49799;
      console.log("base ValorUVT2024 ", ValorUVT2024);
      let ValorSalarioGravableUVT = Number(BaseMensualDeRetencion);
      console.log("base ValorSalarioGravableUVT ", ValorSalarioGravableUVT);
      let retencion = this.calcularRetencionFuente(Number(ValorSalarioGravableUVT));
      console.log("base la retencion es", retencion);
      return retencion;
    },
    calcularRetencionFuente(ingresoMensualCOP) {
      // const UVT_2025 = 47065;
      const UVT_2025 = 49799;
      const ingresoUVT = ingresoMensualCOP / UVT_2025;

      let retencionUVT = 0;

      if (ingresoUVT <= 95) {
        retencionUVT = 0;
      } else if (ingresoUVT <= 150) {
        retencionUVT = (ingresoUVT - 95) * 0.19;
      } else if (ingresoUVT <= 360) {
        retencionUVT = (ingresoUVT - 150) * 0.28 + 10.45;
      } else if (ingresoUVT <= 640) {
        retencionUVT = (ingresoUVT - 360) * 0.33 + 69.29;
      } else if (ingresoUVT <= 945) {
        retencionUVT = (ingresoUVT - 640) * 0.35 + 162.49;
      } else if (ingresoUVT <= 2300) {
        retencionUVT = (ingresoUVT - 945) * 0.37 + 268.84;
      } else {
        retencionUVT = (ingresoUVT - 2300) * 0.39 + 770.06;
      }

      const retencionCOP = Math.round(retencionUVT * UVT_2025);
      console.log({
        ingresoMensualCOP: ingresoMensualCOP,
        ingresoMensualUVT: ingresoUVT.toFixed(2),
        retencionUVT: retencionUVT.toFixed(2),
        retencionCOP: retencionCOP,
      });
      return retencionCOP;
    },
    async getIca() {
      try {
        this.listaItems = [];

        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ListaTablaIca/",
        });
        this.listaIca = res;
      } catch (error) {
        console.log("err", error);
      }
    },
    async obtenerDataProfesional() {
      let mesSeleccionado = new Date(this.anioSeleccionado + "/" + this.mesSeleccionado + "/01").getMonth();
      let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
      this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(anioSeleccionado, mesSeleccionado);
      console.log("periodo", this.Periodo);
      await this.obtenerData(this.Periodo.primerDia, this.Periodo.ultimoDia);
      // obtener otros conceptos
      await this.obtenerOtrosConceptos(this.Periodo.primerDia, this.Periodo.ultimoDia);
      this.PorcentajeSucursal = 0;
      console.log("profesional--->", this.profesional);
      let Persona = await this.$store.dispatch("hl_get", {
        path: "Persona/GetPersonaPorDocumento/" + this.profesional.rut,
      });
      console.log("persona0", Persona);

      let dataProfesional = await this.$store.dispatch("hl_get", {
        path: "FormalEducation/GetByPersonaId/" + Persona.id + "/" + Persona.empresaId,
      });
      console.log("persona-->", dataProfesional);
      if (dataProfesional.length > 0) {
        this.dataProfesional = dataProfesional[0].degree;
        //ahora si obtener el porcentaje de acuerdo a dataprofesional
      }

      //aqui debo llenar lista de sucursales del profesional
      // this.listaSucursal = this.listaItems.reduce((acc, obj) => {
      //   if (!acc.find((item) => item.sucursal === obj.sucursal)) {
      //     acc.push(obj);
      //   }
      //   return acc;
      // }, []);

      this.listaSucursal = this.listaItems.reduce((acc, obj) => {
        if (!acc.includes(obj.sucursal)) {
          // Verifica si la sucursal ya está en el array
          acc.push(obj.sucursal); // Si no está, la agrega
        }
        return acc; // Retorna el array acumulado
      }, []); // Inicializa el acumulador como un array vacío
    },
    async filtrarDataPorSucursal() {
      try {
        console.log("filtrando por sucursal", this.sucursal);
        this.listaItems = this.listaItemsbk.filter((x) => x.sucursal == this.sucursal);
        this.otrosConceptos = this.otrosConceptosBk.filter((x) => x.sucursal == this.sucursal);
        console.log("filtrando por sucursal", this.listaItems);
        console.log("filtrando por sucursal", this.otrosConceptos);
        await this.obtenerPorcentajeSucursal();
        //abr calcular ica, filtrar tabla ica x sucursal
        console.log("dataica", this.listaIca);
        this.dataIca = this.listaIca.filter((x) => x.sedeHelexium == this.sucursal)[0];
        console.log("dataica", this.dataIca);
      } catch (error) {
        console.log("error en filtrarporsucursal", error);
      }
    },
    async calculoTotalesv2() {
      try {
        //paso 1 calcular totales sin tomar en cuenta porcentaje y otros conceptos eso es al final
        console.log("totalttos-->", this.listattos);
        this.totalTtosRealizados = this.listattos.reduce((accumulator, currentItem) => {
          const valueToAdd = Number(currentItem.valor);

          return accumulator + valueToAdd;
        }, 0);
        console.log("totalttos-->", this.totalTtosRealizados);
        this.totalCostosMaterial = this.listaItemsMaterial.reduce((accumulator, currentItem) => {
          const valueToAdd = parseFloat(currentItem.valor);
          return accumulator + valueToAdd;
        }, 0);
        this.totalCostosRemision = this.listaItemsRemision.reduce((accumulator, currentItem) => {
          const valueToAdd = parseFloat(currentItem.valor);
          return accumulator + valueToAdd;
        }, 0);
        this.totalCostosLaboratorio = this.listaLaboratorio.reduce((accumulator, currentItem) => {
          const valueToAdd = parseFloat(currentItem.valor);
          return accumulator + valueToAdd;
        }, 0);
        this.totalNetoHonorarios =
          // Number(this.totalNetoHonorarios) +
          Number(this.totalTtosRealizados) - Number(this.totalCostosMaterial) - Number(this.totalCostosRemision) - Number(this.totalCostosLaboratorio);
        console.log("paso 1 ", this.totalNetoHonorarios.toFixed(2));
        // console.log('paso1 totalnet',this.totalNetoHonorarios)
        console.log("paso1 totalttosrealizados ", this.totalTtosRealizados);
        console.log("paso1 totalcostosmaterial ", this.totalCostosMaterial);
        console.log("paso1 totalcostosremision ", this.totalCostosRemision);
        console.log("paso1 totalcostoslaboratorio ", this.totalCostosLaboratorio);
        //paso 2 calcular valores a excluir del porcentaje en otros conceptos
        let totalAgregadosExcluidos = 0;
        let listaAgregadosExcluidos = this.otrosConceptos.filter((x) => x.tipo == "Agregado" && x.excluirPorcentaje);
        totalAgregadosExcluidos = listaAgregadosExcluidos.reduce((accumulator, currentItem) => {
          const valueToAdd = parseFloat(currentItem.valor);
          return accumulator + valueToAdd;
        }, 0);

        let totalDescuentosExcluidos = 0;
        let listaDescuentosExcluidos = this.otrosConceptos.filter((x) => x.tipo == "Descuento" && x.excluirPorcentaje);
        totalDescuentosExcluidos = listaDescuentosExcluidos.reduce((accumulator, currentItem) => {
          const valueToAdd = parseFloat(currentItem.valor);
          return accumulator + valueToAdd;
        }, 0);

        this.totalDescuentosExcluidos = totalDescuentosExcluidos;
        this.totalAgregadosExcluidos = totalAgregadosExcluidos;

        console.log("paso2", listaAgregadosExcluidos);
        console.log("paso2", listaDescuentosExcluidos);
        console.log("paso2", totalAgregadosExcluidos);
        console.log("paso2", totalDescuentosExcluidos);
        //paso 3 totalizar valores del paso 1, aplicar descuentos o incrementos  a valores paso 1 para generar 1 solo total
        this.totalAgregados = 0;
        this.totalDescuentos = 0;
        let listaAgregados = this.otrosConceptos.filter((x) => x.tipo == "Agregado" && x.excluirPorcentaje != true);
        let totalAgregados = listaAgregados.reduce((accumulator, currentItem) => {
          const valueToAdd = parseFloat(currentItem.valor);
          return accumulator + valueToAdd;
        }, 0);
        let listaDescuentosttos = this.otrosConceptos.filter((x) => x.tipo == "Descuento" && x.excluirPorcentaje != true);
        let totalDescuentosttos = listaDescuentosttos.reduce((accumulator, currentItem) => {
          const valueToAdd = parseFloat(currentItem.valor);
          return accumulator + valueToAdd;
        }, 0);
        this.totalDescuentos = Number(totalDescuentosttos); //+ Number(totalDescuentos);
        this.totalAgregados = Number(totalAgregados); //+ Number(totalAgregados);
        this.totalNetoHonorarios = Number(this.totalNetoHonorarios) + Number(this.totalAgregados) - Number(this.totalDescuentos);
        console.log("paso3", listaAgregados);
        console.log("paso3", listaDescuentosttos);
        console.log("paso3", totalAgregados);
        console.log("paso3", totalDescuentosttos);

        //paso 4 aplicar porcentaje a total general
        this.TotalHonorarios = (this.totalNetoHonorarios * this.PorcentajeSucursal) / 100;
        console.log("paso 4", this.TotalHonorarios);
        //paso 5 aplicar descuentos o incrementos de valores excluidos porcentaje a total general
        this.totalFinalNetoHonorarios = Number(this.TotalHonorarios) + Number(this.totalAgregadosExcluidos) - Number(this.totalDescuentosExcluidos);
        //imprimiendo valores

        ///calculos totales///////////////////////////////////////////
      } catch (error) {
        console.log("error", error);
      }
    },
    async obtenerPorcentajeSucursal() {
      try {
        this.$isLoading(true);
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ObtenerFullPorcentajeSucursal/" + this.sucursal + "/" + this.dataProfesional,
        });
        this.PorcentajeSucursal = res;
        console.log("this.PorcentajeSucursal ", this.PorcentajeSucursal);
        //abr 19022024
        if (this.PorcentajeSucursal.excepcion.toUpperCase().includes(this.profesional.nombreProfesional.toUpperCase())) {
          this.PorcentajeSucursal = this.PorcentajeSucursal.excepcion.split("-")[1];
        } else {
          this.PorcentajeSucursal = this.PorcentajeSucursal.porcentaje;
        }
        console.log("this.PorcentajeSucursal2 ", this.PorcentajeSucursal);
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        this.PorcentajeSucursal = 0;
        console.log("this.PorcentajeSucursal3 error", error);
      }
      // try {
      //   this.$isLoading(true);
      //   let res = await this.$store.dispatch("denti_get", {
      //     path: "Prestaciones/ObtenerPorcentajeSucursal/" + this.sucursal,
      //   });
      //   this.PorcentajeSucursal = res;
      //   this.$isLoading(false);
      // } catch (error) {
      //   this.$isLoading(false);
      //   this.PorcentajeSucursal = 0;
      // }
    },
    cadenaMes() {
      let numero = this.mesSeleccionado;
      const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      // Verificar que el número esté en el rango válido (1-12)
      if (numero < 1 || numero > 12) {
        return "Número inválido. Debe estar entre 1 y 12.";
      }

      // Restar 1 para obtener el índice correcto del mes
      return meses[numero - 1];
    },
    verResumen() {
      this.$bvModal.show("resumen");
    },
    showToast(type, message) {
      console.log(type);
      if (type == "success") {
        this.$toast.success(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
      if (type == "error")
        this.$toast.error(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      if (type == "warning")
        this.$toast.warning(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
    },

    verModal() {
      this.$bvModal.show("nuevoServicio");
    },

    exportToExcel() {
      // Crear las hojas de datos de cada array con títulos y sumatorias
      const sheet1 = this.createSheetWithSum(this.listaItems, "Prestaciones", "valorPrestacion");
      const sheet2 = this.createSheetWithSum(this.listaItemsMaterial, "Material Especial", "valor");
      const sheet3 = this.createSheetWithSum(this.listaLaboratorio, "Costos Laboratorio", "valorPrestacion");

      // Crear un nuevo libro de trabajo
      const wb = XLSX.utils.book_new();

      // Agregar cada hoja de trabajo con el nombre deseado
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sheet1), "Prestaciones");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sheet2), "Material Especial");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sheet3), "Costos Laboratorio");

      // Exportar el archivo Excel
      // XLSX.writeFile(wb, 'datos_separados.xlsx');
      XLSX.writeFile(wb, "Liquidación-" + this.profesional + "-" + this.mesSeleccionado + "-" + this.anioSeleccionado + "-" + this.sucursal + ".xlsx");
    },

    // Función para crear una hoja con sumatoria
    createSheetWithSum(data, title, sumColumn) {
      // Verificar si el array de datos está vacío
      if (!data || data.length === 0) {
        console.warn(`El array ${title} está vacío o no está definido.`);
        return [[title], ["No hay datos disponibles"]]; // Retorna un mensaje si el array está vacío
      }

      const headers = Object.keys(data[0]); // Obtener encabezados de las claves del array
      const sheetData = [];

      // Agregar los encabezados de las columnas
      sheetData.push(headers);

      // Agregar los datos del array
      data.forEach((item) => {
        sheetData.push(headers.map((key) => item[key]));
      });

      // Calcular y agregar la fila de sumatoria
      const sumRow = headers.map((key) => (key === sumColumn ? this.sumColumn(data, key) : ""));
      sheetData.push(["Total", ...sumRow.slice(1)]); // Agregar 'Total' y la sumatoria

      return sheetData;
    },

    // Función para calcular la sumatoria de una columna específica
    sumColumn(data, column) {
      return data.reduce((sum, item) => {
        const value = Number(item[column]); // Convertir a número
        return sum + (isNaN(value) ? 0 : value); // Sumar solo si es un número válido
      }, 0);
    },

    async filtrar(item) {
      // this.otrosConceptos = [];
      // this.listaItems = [];
      if (item == 1) {
        this.profesional = null;
        this.sucursal = null;
        ////////
        this.$isLoading(true);
        await this.obtenerEstadoLiquidacion();
        console.log("estadoliquidacion ", this.estadoLiquidacion);
        //if (this.estadoLiquidacion != null && this.estadoLiquidacion.estado == 1) {
        let mesSeleccionado = new Date(this.anioSeleccionado + "/" + this.mesSeleccionado + "/01").getMonth();
        let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
        this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(anioSeleccionado, mesSeleccionado);
        await this.getData(this.Periodo.primerDia, this.Periodo.ultimoDia);
        // } else {
        //   Swal.fire("Aviso!", "Aún no hay datos disponibles para el período seleccionado.", "error");
        // }
        //filtrar x mes y año
        this.$isLoading(false);
      }
      if (item == 2) {
        //problema: no existe rut del profesional en prestaciones
        try {
          this.$isLoading(true);

          console.log("this.listaItems ", this.listaItems);
          this.listattos = this.listaItems.filter((x) => x.concepto == "Ttos. realizados, cancelados y evolucionados");
          console.log("ttos ", this.listattos);
          this.listaItemsMaterial = this.listaItems.filter((x) => x.concepto == "Costos material especial");
          console.log("material ", this.listaItemsMaterial);
          this.listaItemsRemision = this.listaItems.filter((x) => x.concepto == "Costos de remisión");
          console.log("remision--> ", this.listaItemsRemision);

          this.listaLaboratorio = this.listaItems.filter((x) => x.concepto == "Costos Laboratorio");
          console.log("listaLaboratorio ", this.listaLaboratorio);

          // totalizando datos
          ///////////////////////
          await this.calculoTotalesv2();

          this.$forceUpdate();
          this.$isLoading(false);
        } catch (error) {
          this.$isLoading(false);
        }
        //console.log("profesional data", this);
        // idProfesional = idProfesional[0].rut;
        // console.log("profesional data", idProfesional);
      }
    },
    async obtenerData(primerDia, ultimoDia) {
      console.log("proff", this.profesional);
      this.listaItems = [];
      let res = await this.$store.dispatch("denti_get", {
        path: "Prestaciones/MiHonorarioPorProfesionalFecha/" + this.profesional.nombreProfesional + "/" + primerDia + "/" + ultimoDia,
      });
      this.listaItems = res;
      this.listaItemsbk = res;

      this.CodigoRetencionEnLaFuente = {};
      res = await this.$store.dispatch("hl_get", {
        path: "Persona/GetPersonaRetencionEnLaFuenteArt/" + this.profesional.rut + "/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
      });
      this.CodigoRetencionEnLaFuente = res;
      console.log("retencion en la fuente", JSON.stringify(this.CodigoRetencionEnLaFuente));
    },
    async obtenerOtrosConceptos(primerDia, ultimoDia) {
      this.otrosConceptos = [];
      let res = await this.$store.dispatch("denti_get", {
        path: "Prestaciones/ListaOtrosConceptosPorProfesional/" + primerDia + "/" + ultimoDia + "/" + this.profesional.nombreProfesional + "/",
      });
      console.log("otros", res);
      // this.otrosConceptos = res;
      this.otrosConceptosBk = res;
    },

    obtenerPrimerYUltimoDiaDelMes(anio, mes) {
      // El mes en JavaScript es base 0, por lo que enero es 0 y diciembre es 11
      const primerDia = new Date(anio, mes, 1);
      const ultimoDia = new Date(anio, mes + 1, 0); // El día 0 del mes siguiente es el último día del mes actual

      return {
        primerDia: primerDia.toISOString().split("T")[0], // Formato YYYY-MM-DD
        ultimoDia: ultimoDia.toISOString().split("T")[0],
      };
    },
    async getData(primerDia, ultimoDia) {
      try {
        if (window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
          window.$("#datatable_registroServicios").DataTable().destroy();
        }
        this.listaItems = [];
        // console.log("getdata dentisalud", Periodo);
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ListaProfesionalesPorPeriodo/" + primerDia + "/" + ultimoDia,
        });
        console.log("res dentisalud ", res);

        // this.listaProfesional = res.map((x) => ({
        //   // console.log(x.profesional.nombreProfesional);
        //   nombreProfesional: x.nombreProfesional,
        // }));

        let uniqueProfesionales = new Set();

        let idCounter = 1;
        this.listaProfesional = res
          .map((x) => {
            console.log("x-->0", x);
            let nombreProfesional = x.profesional.nombreProfesional;

            // Verificar si el nombreProfesional es único
            if (nombreProfesional && !uniqueProfesionales.has(nombreProfesional)) {
              uniqueProfesionales.add(nombreProfesional);
              return {
                id: idCounter++, // ID incremental
                nombreProfesional: nombreProfesional,
                rut: x.profesional.rut,
              };
            }
            return null; // Ignorar duplicados
          })
          .filter((item) => item !== null); // Eliminar los nulls del array final

        console.log("lista profesionales", this.listaProfesional);
        // this.listaSucursal = res.map((pa) => pa.sucursalPpto).filter((nombrep, indexp, selfp) => selfp.indexOf(nombrep) === indexp);
        // this.listaSucursal.sort((a, b) => {
        //   if (a < b) return -1;
        //   if (a > b) return 1;
        //   return 0;
        // });

        // console.log("pacientes ", this.listaPacientes);
        // console.log("list registroServicios...", res);
        // if (res.success) {
        //   this.listaItems = res.data.map((service) => {
        //     return {
        //       ...service,
        //       placa: this.getPlacaVehiculo(service.placaId),
        //       estado: service.fechaFin ? true : false,
        //     };
        //   });
        //   // console.log(this.listaItems);
        // } else {
        //   this.listaItems = [];
        // }
        this.$isLoading(false);

        // this.$nextTick(function () {
        //   if (!window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
        //     window.$("#datatable_registroServicios").DataTable();
        //   }
        // });

        // core.index();

        // if (window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
        //   window.$("#datatable_registroServicios").DataTable().destroy();
        // }
        // this.dataTableInstance = window.$("#datatable_registroServicios").DataTable({
        //   language: {
        //     url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        //   },
        // });
        // this.$forceUpdate();
      } catch (error) {
        this.$isLoading(false);

        this.listaItems = [];
        console.log("err dentisalud ", error);
      }
    },
    async obtenerEstadoLiquidacion() {
      try {
        this.otrosConceptos = [];
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/EstadoPeriodoLiquidacion/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
        });
        this.estadoLiquidacion = res;
      } catch (error) {
        console.log("error", error);
        this.estadoLiquidacion = null;
      }
    },
  },
};
</script>

<style scoped>
.custom-popup {
  background-color: #f0f8ff;
  border-radius: 10px;
  padding: 1em;
  font-size: 1rem !important;
}

.custom-title {
  color: #333;
  font-size: 0.5rem !important;
  font-weight: bold;
}

.custom-input {
  border: 1px solid #ddd;
  padding: 0.5em;
  border-radius: 5px;
}

.custom-confirm-button {
  background-color: #4caf50;
  color: white;
  padding: 0.5em 1.5em;
}

.custom-cancel-button {
  background-color: #f44336;
  color: white;
}
</style>
